<template>
  <svg
    class="portal-icon"
    :class="customClass"
    :width="size"
    :height="size"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
  >
    <path
      v-for="(seg, idx) in paths"
      :key="idx"
      :d="seg.d"
      :fill="segFill(seg)"
      :stroke="segStroke(seg)"
      :stroke-width="segStrokeWidth(seg)"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
</template>

<script>
import { getPortalIconPaths } from "@/constants/portalIcons";

export default {
  name: "PortalIcon",
  props: {
    /** 语义名或 el-icon-*（经 resolvePortalIcon 转换） */
    name: {
      type: String,
      default: "tag",
    },
    size: {
      type: [Number, String],
      default: 20,
    },
    customClass: {
      type: String,
      default: "",
    },
    /** 描边粗细，默认 1.5（对齐 iconfont 线性图标） */
    strokeWidth: {
      type: [Number, String],
      default: 1.5,
    },
  },
  computed: {
    paths() {
      return getPortalIconPaths(this.name);
    },
  },
  methods: {
    segFill(seg) {
      if (seg.fill === "currentColor") return "currentColor";
      if (seg.stroke === "none") return seg.fill || "currentColor";
      return seg.fill || "none";
    },
    segStroke(seg) {
      if (seg.stroke === "none" || seg.fill === "currentColor") return "none";
      return "currentColor";
    },
    segStrokeWidth(seg) {
      if (seg.stroke === "none" || seg.fill === "currentColor") return 0;
      return seg.sw || this.strokeWidth;
    },
  },
};
</script>

<style scoped>
.portal-icon {
  display: block;
  flex-shrink: 0;
}
</style>
